export default "__VITE_ASSET__BJkEe0zh__"